import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=4f72bcfc&scoped=true"
import script from "./ViewEdit.vue?vue&type=script&lang=js"
export * from "./ViewEdit.vue?vue&type=script&lang=js"
import style0 from "./ViewEdit.vue?vue&type=style&index=0&id=4f72bcfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72bcfc",
  null
  
)

export default component.exports